module.exports = __webpack_public_path__ + "resources/img/img_ahnlab_cpp2_m_en.831cedcd99484cb693d8660dcade5225.png";